import Vue from 'vue'
import VueRouter from 'vue-router'
import InvoiceCreate from '../views/InvoiceCreate.vue'
import InvoiceList from '../views/InvoiceList.vue'

Vue.use(VueRouter)

const routes = [
  { path: '/', redirect: '/list' },
  { path: '/list', name: 'List', component: InvoiceList },
  { path: '/create', name: 'Create', component: InvoiceCreate },
  { path: '/create/:id', name: 'Edit', component: InvoiceCreate }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
